import React, { useRef } from "react";
import { useTranslation } from "locales";
import { BaseMenuItemInterface } from "types";
import BaseButton from "components/BaseButton";
import BaseInputFile from "components/BaseInputFile";
import BaseMenu from "components/BaseMenu";
import "./style.scss";

interface Props {
  className?: string;
  onInput: (files: File[]) => void;
  onVideoRecord?: () => void;
}

function MessageAttachButton({ className, onInput, onVideoRecord }: Props) {
  const clickImageRef = useRef<HTMLInputElement | null>(null);
  const clickVideoRef = useRef<HTMLInputElement | null>(null);
  const clickAudioRef = useRef<HTMLInputElement | null>(null);
  const clickDocumentRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();

  const cls = [];
  if (className) cls.push(className);

  const itemsList: BaseMenuItemInterface[] = [
    {
      name: "image",
      icon: "image",
      title: t("Image"),
    },
    {
      name: "video",
      icon: "camera",
      title: t("Video"),
    },
    {
      name: "audio",
      icon: "audio",
      title: t("Audio"),
    },
    {
      name: "document",
      icon: "document",
      title: t("Document"),
    },
    ...(onVideoRecord ? [{
      name: "round-video",
      icon: "camera",
      title: t("Round Video"),
    }] : []),
  ];

  const onClickItem = (itemName: string) => {
    if (itemName === "round-video" && onVideoRecord) {
      return onVideoRecord();
    }
    if (itemName === "image" && clickImageRef.current) {
      return clickImageRef.current.click();
    }
    if (itemName === "video" && clickVideoRef.current) {
      return clickVideoRef.current.click();
    }
    if (itemName === "audio" && clickAudioRef.current) {
      return clickAudioRef.current.click();
    }
    if (itemName === "document" && clickDocumentRef.current) {
      return clickDocumentRef.current.click();
    }
  };

  return (
    <div className={cls.join(" ")}>
      <BaseMenu className="message-attach-btn__menu" itemsList={itemsList} onClick={onClickItem} spaced={true}>
        <BaseButton icon={true} opacity={true} name="attach-file">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
          </svg>
        </BaseButton>
      </BaseMenu>
      <BaseInputFile name={"image"} accept="image" multiple={true} onInput={onInput} inputRef={clickImageRef} />
      <BaseInputFile name={"video"} accept="video" multiple={true} onInput={onInput} inputRef={clickVideoRef} />
      <BaseInputFile name={"audio"} accept="audio" multiple={true} onInput={onInput} inputRef={clickAudioRef} />
      <BaseInputFile name={"document"} accept="document" multiple={true} onInput={onInput} inputRef={clickDocumentRef} />
    </div>
  );
}

export default MessageAttachButton;
